import React from 'react';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import SelectField from 'components/pure/utils/form/SelectField';
import CallColorsRow from 'components/manager-dashboard/conversation-timeline/CallColorsRow';

export default class CallColorsConfig extends React.Component {
  constructor(props) {
    super(props);

    this.colorChanged = this.colorChanged.bind(this);
    this.valueChanged = this.valueChanged.bind(this);
    this.addRow = this.addRow.bind(this);
    this.removeRow = this.removeRow.bind(this);
  }

  colorChanged(index, colorIndex) {
    const colorList = this.props.colorList;
    const item = colorList.get(index);
    const newList = colorList.set(index, {colorIndex, value: item.value});
    this.props.colorListUpdated(newList);
  }

  valueChanged(index, value) {
    const colorList = this.props.colorList;
    const item = colorList.get(index);
    const newList = colorList.set(index, {colorIndex: item.colorIndex, value});
    this.props.colorListUpdated(newList);
  }

  addRow() {
    const colorList = this.props.colorList.push({colorIndex: 0, value: null});
    this.props.colorListUpdated(colorList);
    if (this.rowContainer) {
      setTimeout(() => (this.rowContainer.scrollTop = this.rowContainer.scrollHeight), 0);
    }
  }

  removeRow(index) {
    const colorList = this.props.colorList.remove(index);
    this.props.colorListUpdated(colorList);
  }

  render() {
    const {searchFieldSelect, searchFieldOptions, selectedSearchFieldId, colorList} = this.props;

    // already selected values
    const selectedValues = colorList.map(item => item.value);

    return (
      <div className="call-colors-config-container">
        <div className="call-colors-config color-container">
          <div>Choose an enumerated field and then map values to colors</div>
          <div className="select-field">
            <FieldContainer label="Field">
              <SelectField
                name="searchField"
                hideResetButton={true}
                tether={true}
                className=""
                value={selectedSearchFieldId}
                options={searchFieldSelect}
                onChange={this.props.searchFieldChanged}
              />
            </FieldContainer>
            <div className="default-color">
              Default Color: <div className="default-color-block colordefault"></div>
            </div>
            <div className="color-rows-container" ref={c => (this.rowContainer = c)}>
              {colorList.map((item, index) => (
                <CallColorsRow
                  key={index}
                  selectedColor={item.colorIndex}
                  colorChange={colorIndex => this.colorChanged(index, colorIndex)}
                  selectedValue={item.value}
                  dropdownValues={searchFieldOptions}
                  valueChange={item => this.valueChanged(index, item)}
                  removeRow={() => this.removeRow(index)}
                  selectedValues={selectedValues}
                />
              ))}
            </div>
            <div className="add-color-row" onClick={this.addRow}>
              + add new
            </div>
          </div>
        </div>
      </div>
    );
  }
}
